<template>
  <div class="feature-3" :id="feature.id">

    <div class="feature-header lead-1-large">
      <div v-html="feature.name"></div>
    </div>
    <div class="info-wrapper" :class="{more: moreOpened}">
      <div class="feature-content-wrapper" >
        <div class="asset-container">
          <img :src="feature.image" alt="">
        </div>

        <div class="info-container">
          <div class="field-box-title lead-1" v-if="feature.title">{{ feature.title }}</div>
          <div class="field-box-subtitle paragraph-1" v-html="feature.subTitle"></div>
          <seu-button
            :label="moreOpened? feature.buttonLabelLess :feature.buttonLabel"
            :button-icon-after="rightArrow"
            @click="toggleMore"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeuButton from "/seu-frontend/components/SeuButton";

export default {
  name: 'Feature3',
  components: {SeuButton},
  props: {
    feature: {
      type: Object
    }
  },
  data: () => ({
    rightArrow: require('../../assets/icons/arrow-triangle-down.svg'),
    moreOpened: false
  }),

  methods: {
    toggleMore() {
      this.moreOpened = !this.moreOpened
      if(this.moreOpened) {
        this.$emit('open')
      }
    },

    closeMore() {
      this.moreOpened = false
    }
  }

}
</script>

<style lang="scss">
@import "Feature3";
</style>
